var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close-icon",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleCloseClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }